import React from 'react';

import { Box, Typography } from '@mui/material';

import styles from './kbaQuizScreen.module.css';

import { ReactComponent as BackArrow } from 'asset/IconsPack/at_arrow-left-thin.svg';

import { KBA_TIMER, KBA_TITLE } from '../../helper/constants';

const QuizHeader = () => (
    <>
        <Box className={styles.headerTop}>
            <BackArrow className={styles.backArrow} />
            <Typography className={styles.title}>{KBA_TITLE}</Typography>
        </Box>
        <Box className={styles.timer}>
            <Typography className={styles.timerValue}>{KBA_TIMER}</Typography>
        </Box>
    </>
);

export default QuizHeader;
